import requests from "../../api/requests";

// All products
export const fetchCatigory = () => (dispatch) => {
  dispatch({ type: "fetch_category_start" });

  requests
    .fetchCatigory()
    .then(({ data }) => {
      dispatch({ type: "fetch_category_success", payload: data });
    })
    .catch(({ response }) => {
      let message = (response && response.data.message) || "Mahsulot topilmadi";
      dispatch({ type: "fetch_category_error", payload: message });
    });
};
